import Styles from './Certificate.module.scss';
import { useContext, useRef } from 'react';
import { useParams } from 'react-router-dom';
import {QRCodeSVG} from 'qrcode.react';

// Module imports.
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import FeatherIcon from 'feather-icons-react';

// Components import.
import { useAPI, Content, Message, AuthContext, useTranslation } from 'components/lib';
import { AivagamButton } from 'components/global/AivagamButton/AivagamButton';
import { LoadingBackdrop } from 'components/global/LoadingBackdrop/LoadingBackdrop';
import { CertificateGenerator } from 'components/global/CertificateGenerator/CertificateGenerator';

export function Certificate(props) {

	const { t } = useTranslation();
	const authContext = useContext(AuthContext);
	const { user_cert_id } = useParams();
	const { data, loading } = useAPI(`/api/certificate/${user_cert_id}`);
	const certRef = useRef(null);

	const dateObj = new Date(data?.dateUnlocked);
	//Format the Date object into "11 Aug 2023" format
	const options = { year: 'numeric', month: 'short', day: 'numeric' };
	const formattedDate = dateObj.toLocaleDateString('en-US', options);
	const certificateUrl = `${process.env.REACT_APP_URL}/certificate/${user_cert_id}`;

	const handleDownloadPDF = async () => {
		const element = certRef.current;
		if (!element) return;
		const canvas = await html2canvas(element, {
			scale: 1,
			useCORS: true,
		});
		const imgData = canvas.toDataURL('image/png');
		const pdf = new jsPDF({
			orientation: 'landscape',
			unit: 'mm',
			format: 'a4',
		});
		const imgWidth = 297;
		const imgHeight = (canvas.height * imgWidth) / canvas.width;
		const imgX = 0;
		const imgY = (210 - imgHeight) / 2;
		pdf.addImage(imgData, 'PNG', imgX, imgY, imgWidth, imgHeight);
		pdf.save(`certificate_${user_cert_id}.pdf`);
	};

	return (
		<>
			<LoadingBackdrop isOpen={loading} />
			{data?.firstName ? (
				<>
					<LoadingBackdrop isOpen={loading} />
					<div className={Styles.cert_container}>
						<AivagamButton
							icon
							buttonText={
								<>
									<FeatherIcon
										color='white'
										icon='download'
									/>
									{t('LearningPath.Certificate.button')}	</>
							}
							onClick={handleDownloadPDF}
							type={"confirm"}
						/>
						<CertificateGenerator
							id='certContainer'
							ref={certRef}
							firstName={`${data?.firstName || 'First Name'}`}
							lastName={`${data?.lastName || 'Last Name'}`}
							message={data?.certName}
							issueDate={`${formattedDate}`}
							userCertId={user_cert_id}
							isMicroCert={!data?.nasscomCertified}
							qrCode={<QRCodeSVG bgColor={'#004bb1'} fgColor='#FFFFFF' value={certificateUrl} size={100} />}
						/>
					</div>
				</>
			) : (
				<Content>
					<Message
						type='alert'
						title={t('LearningPath.Certificate.message.title')}
						text={t('LearningPath.Certificate.message.descr')}
						buttonText={t('LearningPath.Certificate.message.button')}
						buttonLink={authContext?.user?.authenticated ? '/navigate' : '/'}
					/>
				</Content>
			)}
		</>
	);
}
